/* eslint-disable comma-dangle */
/* eslint-disable indent */
class CustomerReviews extends HTMLElement {
  set review(reviews) {
    this._reviews = reviews;
    this.render();
  }

  render() {
    this.innerHTML = `<div class="reviews">
    ${this._reviews
      .map(
        (item) => `
        
          <div class="customer-reviews">
            <h5>${item.name}&nbsp&nbsp<span class="review-date">${item.date}</span></h5>
            <p class="review-content">${item.review}</p>
          </div>
        `
      )
      .join('')}</div>`;
  }
}

customElements.define('customer-reviews', CustomerReviews);
